module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.parentSection.paginated || (!_vm.parentSection.isComplete || _vm.parentSection.isActive)) ? _c('div', {
    staticClass: "rf-section-nav",
    class: _vm.computedClass,
    attrs: {
      "tabindex": this.disabled ? -1 : 0
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.onClick($event)
      },
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.onClick($event)
      },
      "mousedown": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
      }
    }
  }, [_vm._t("default")], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f8804918","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/frontend/components/RfSectionNav.vue
// module id = 265
// module chunks = 0